import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";

export default function NotFound() {
  return (
    <section className="container-prose py-24 text-center relative">
      <div
        aria-hidden
        className="orb -top-10 left-1/3 h-60 w-60 animate-float"
        style={{ background: "radial-gradient(closest-side, #d7c8ff, transparent)" }}
      />
      <Reveal>
        <span className="pill">404</span>
        <h1 className="mt-5 font-display text-5xl sm:text-6xl">
          This page has <em className="not-italic grad-text">wandered off.</em>
        </h1>
        <p className="mt-4 text-ink-500">Let's head back somewhere useful.</p>
        <Link to="/" className="btn-primary mt-8 inline-flex">
          Return home
        </Link>
      </Reveal>
    </section>
  );
}
